import { Theme } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

interface ChatContainerStylesProps {
  conversationSelected: boolean
  hideEngagementHub: boolean
}
const useStyles = makeStyles<Theme, ChatContainerStylesProps>(theme => ({
  root: {
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateColumns: ({ conversationSelected }) =>
      conversationSelected
        ? 'minmax(220px, 320px) minmax(460px, 1fr) minmax(220px, 320px)'
        : 'minmax(220px, 320px) minmax(460px, 1fr)',
    width: '100%',
    [theme.breakpoints.down(1025)]: {
      gridTemplateColumns: ({ conversationSelected, hideEngagementHub }) =>
        hideEngagementHub
          ? `minmax(220px, 220px) minmax(460px, 1fr) 1px`
          : conversationSelected
          ? 'minmax(220px, 220px) minmax(460px, 1fr) minmax(220px, 220px)'
          : 'minmax(220px, 220px) minmax(460px, 1fr)'
    }
  }
}))

export default useStyles
